import React from "react";
import { Box, BoxProps } from "@amzn/awsui-components-react-v3";
import { SpaceBetween } from "@amzn/awsui-components-react-v3/polaris";

interface SplashScreenProps {
  icon: React.ReactNode;
  text: string;
  subtext?: string;
  subtextColor?: BoxProps.Color;
}

export const SplashScreen = ({
  icon,
  text,
  subtext,
  subtextColor = "text-body-secondary",
}: SplashScreenProps) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "90vh",
    }}
  >
    <Box textAlign="center">
      <SpaceBetween size="l">
        {icon}
        <Box fontSize="heading-s" fontWeight="heavy">
          {text}
        </Box>
        {subtext && (
          <Box fontSize="body-s" color={subtextColor}>
            {subtext}
          </Box>
        )}
      </SpaceBetween>
    </Box>
  </div>
);
